import Translate, { Message } from "../util/messages/GeralMessages";

export const Menu = [
  {
    name: Translate(Message.Menu.Home),
    icon: "si si-home",
    routerLink: "/app",
  },
  {
    name: Translate(Message.Menu.Quotation),
    icon: "si si-notebook",
    routerLink: "/quotation",
  },
  {
    name: Translate(Message.Menu.Tracking),
    icon: "si si-pin",
    routerLink: "/tracking",
  },
  {
    name: Translate(Message.Menu.Documents),
    icon: "far fa-file",
    routerLink: "/documents",
  },
  {
    name: Translate(Message.Menu.MyDeliveries),
    icon: "si-cusi si-globe-alt",
    routerLink: "/deliveries",
  },
  {
    name: Translate(Message.Menu.AddressList),
    icon: "si si-wallet",
    routerLink: "/AddressBook",
  },
  {
    name: Translate(Message.Menu.Billing),
    icon: "si si-wallet",
    routerLink: "/charging",
  },
  {
    name: Translate(Message.Menu.Profile),
    icon: "si si-user",
    routerLink: "/profile",
  },
];
